import { render, staticRenderFns } from "./CompraIdeas.vue?vue&type=template&id=3f0e3fcc&"
import script from "./CompraIdeas.vue?vue&type=script&lang=js&"
export * from "./CompraIdeas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports